module.exports = __webpack_public_path__ + "img/register-image.961dfd6c.png";